/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CreateGuestRequest,
  GetApiGuestList200,
  GetApiGuestListParams,
  GuestApiResource,
  UnauthorizedErrorResponse,
  UpdateGuestRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiGuestListResponse200 = {
  data: GetApiGuestList200
  status: 200
}

export type getApiGuestListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiGuestListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiGuestListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiGuestListResponseSuccess = (getApiGuestListResponse200) & {
  headers: Headers;
};
export type getApiGuestListResponseError = (getApiGuestListResponse400 | getApiGuestListResponse401 | getApiGuestListResponse403) & {
  headers: Headers;
};

export type getApiGuestListResponse = (getApiGuestListResponseSuccess | getApiGuestListResponseError)

export const getGetApiGuestListUrl = (params?: GetApiGuestListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/guests?${stringifiedParams}` : `/api/guests`
}

export const getApiGuestList = async (params?: GetApiGuestListParams, options?: RequestInit): Promise<getApiGuestListResponse> => {
  
  return customFetch<getApiGuestListResponse>(getGetApiGuestListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiGuestCreateResponse204 = {
  data: void
  status: 204
}

export type postApiGuestCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiGuestCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiGuestCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiGuestCreateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type postApiGuestCreateResponseSuccess = (postApiGuestCreateResponse204) & {
  headers: Headers;
};
export type postApiGuestCreateResponseError = (postApiGuestCreateResponse400 | postApiGuestCreateResponse401 | postApiGuestCreateResponse403 | postApiGuestCreateResponse409) & {
  headers: Headers;
};

export type postApiGuestCreateResponse = (postApiGuestCreateResponseSuccess | postApiGuestCreateResponseError)

export const getPostApiGuestCreateUrl = () => {


  

  return `/api/guests`
}

export const postApiGuestCreate = async (createGuestRequest: CreateGuestRequest, options?: RequestInit): Promise<postApiGuestCreateResponse> => {
  
  return customFetch<postApiGuestCreateResponse>(getPostApiGuestCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createGuestRequest,)
  }
);}


export type putApiGuestUpdateResponse200 = {
  data: GuestApiResource
  status: 200
}

export type putApiGuestUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiGuestUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiGuestUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiGuestUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiGuestUpdateResponseSuccess = (putApiGuestUpdateResponse200) & {
  headers: Headers;
};
export type putApiGuestUpdateResponseError = (putApiGuestUpdateResponse400 | putApiGuestUpdateResponse401 | putApiGuestUpdateResponse403 | putApiGuestUpdateResponse409) & {
  headers: Headers;
};

export type putApiGuestUpdateResponse = (putApiGuestUpdateResponseSuccess | putApiGuestUpdateResponseError)

export const getPutApiGuestUpdateUrl = (id: number,) => {


  

  return `/api/guests/${id}`
}

export const putApiGuestUpdate = async (id: number,
    updateGuestRequest: UpdateGuestRequest, options?: RequestInit): Promise<putApiGuestUpdateResponse> => {
  
  return customFetch<putApiGuestUpdateResponse>(getPutApiGuestUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateGuestRequest,)
  }
);}


